import styled from "styled-components";

interface SupportProps {
  hasAccess: boolean;
}

export const ContentSupportWpp = styled.div<SupportProps>`
  width: 100%;
  top: 12px;
  border-width: 1px;
  flex-direction: column;


`;

export const ContentCommercial = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 16px;
  justify-content: center;
  cursor: pointer;


`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  border-top: 2px solid #313131;
  margin-bottom: 18px;

  .plan-sidebar {
    font-size: 16px;
    user-select: none;
    color: var(--velotax-font-color-light);
    &.pointer {
      cursor: pointer;
    }
    strong {
      font-weight: 900;
    }
  }
`;

export const ContentNotHasAccess = styled.div`
  width: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const TextContainer = styled.div`
  width: 100%;
  height: 52;
  display: flex;
  flex-direction: column;
  top: 30px;
  left: 16px;
  padding: 8px 8px;
  gap: 8px;
`;

export const Title = styled.span<SupportProps>`
  width: 160px;
  height: 16px;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 500;
  font-size: 22px;
  line-height: 20px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #fbc105;
`;

export const InfoText = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--velotax-font-color);
`;

export const InfoText2 = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--velotax-font-color);
`;

export const ScheduleText = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 300;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: var(--ant-primary-color);
`;

export const Button = styled.button`
  width: 100%;
  height: 40;
  top: 112px;
  left: 20px;
  border-bottom-width: 2px;
  padding: 12px;
  gap: 10px;
  background-color: var(--ant-primary-color) !important;
  color: #FFFFFF;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 28px;
  letter-spacing: 0%;
  vertical-align: middle;
`;

export const WarningContainer = styled.div`
  width: 100%;
  padding: 12px;
  margin-bottom: 16px;
  background-color: var(--ant-warning-1);
  border-left: 3px solid var(--ant-warning-color);
  border-radius: 4px;
`;

export const WarningTitle = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: black;
  margin-bottom: 8px;
`;

export const WarningText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: black
`;

export const ScheduleContainer = styled.div`
  width: 100%;
  padding: 0 12px;
  margin-bottom: 12px;
`;

export const ScheduleTitle = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  color: var(--velotax-font-color);
  margin-bottom: 4px;
`;

export const ScheduleTextContent = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--velotax-font-color);
`;

export const PhoneContainer = styled.div`
  width: 100%;
  padding: 0 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PhoneText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: var(--velotax-font-color);
  
  strong {
    font-weight: 700;
  }
`;